module.exports = __webpack_public_path__ + "img/page_image_3_1.0cc03e0e.svg";